import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddHolidayPopUp from "./add_holiday_popup.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const HolidayPopUp = (props) => {
  const [showAddHolidayPopUp, setShowAddHolidayPopUp] = useState("");

  const openEditHolidayPopUp = (e) => {
    setShowAddHolidayPopUp(true);
  };

  const closeEditHolidayPopUp = (e) => {
    setShowAddHolidayPopUp(false);
  };

  const acceptHoliday = (e) => {
    MySwal.fire({
      title:
        "Czy na pewno zaakceptować " +
        (props.holiday.type === "holiday"
          ? "urlop"
          : props.holiday.type === "sick"
          ? "zwolnienie chorobowe"
          : props.holiday.type === "remote"
          ? "pracę zdalną"
          : "") +
        "?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        acceptHolidayFinal();
        props.close();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const acceptHolidayFinal = async (e) => {
    var body = {
      id: props.holiday.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/acceptHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Zaakceptowano",
      text:
        props.holiday.type === "holiday"
          ? "urlop"
          : props.holiday.type === "sick"
          ? "zwolnienie chorobowe"
          : props.holiday.type === "remote"
          ? "pracę zdalną"
          : "",
    }).then((result) => {
      props.close();
    });
  };

  const deleteHoliday = (e) => {
    MySwal.fire({
      title:
        "Czy na pewno usunąć " +
        (props.holiday.type === "holiday"
          ? "urlop"
          : props.holiday.type === "sick"
          ? "zwolnienie chorobowe"
          : props.holiday.type === "remote"
          ? "pracę zdalną"
          : "") +
        "?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteHolidayFinal();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteHolidayFinal = async (e) => {
    var body = {
      id: props.holiday.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text:
        props.holiday.type === "holiday"
          ? "urlop"
          : props.holiday.type === "sick"
          ? "zwolnienie chorobowe"
          : props.holiday.type === "remote"
          ? "pracę zdalną"
          : "",
    }).then((result) => {
      props.close();
    });
  };

  return (
    <>
      {showAddHolidayPopUp ? (
        <AddHolidayPopUp
          close={closeEditHolidayPopUp}
          users={props.users}
          mode={"edit"}
          holiday={props.holiday}
          user={props.user}
          holidaysBlockData={props.holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          holidaysData={props.holidaysData}
          type={props.holiday.type}
        />
      ) : (
        ""
      )}
      <div className="mainContainerHolidayPopUp">
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="hearingTitle">
          {props.holiday.type === "holiday"
            ? "Urlop"
            : props.holiday.type === "sick"
            ? "Zwolnienie chorobowe"
            : props.holiday.type === "remote"
            ? "Praca zdalna"
            : ""}{" "}
          <span className="highlight">{props.holiday.user}</span>
        </div>
        <div className="holidayContent">
          <p>Data od: {props.holiday.date_from}</p>
          <p>Data do: {props.holiday.date_to}</p>
          {props.holiday.type === "holiday" ? (
            <p>
              Status:{" "}
              {props.holiday.status === "REPORTED"
                ? "ZGŁOSZONY"
                : "ZAAKCEPTOWANY"}
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="holidayFunctionalites">
          {props.mode === "user" ? (
            ""
          ) : props.holiday.status !== "ACCEPTED" ? (
            <button className="paymentMenuButton" onClick={acceptHoliday}>
              ZAAKCEPTUJ{" "}
              {props.holiday.type === "holiday"
                ? "URLOP"
                : props.holiday.type === "sick"
                ? "CHOROBOWE"
                : props.holiday.type === "remote"
                ? "PRACĘ ZDALNĄ"
                : ""}
            </button>
          ) : (
            ""
          )}
          <button className="paymentMenuButton" onClick={openEditHolidayPopUp}>
            EDYTUJ{" "}
            {props.holiday.type === "holiday"
              ? "URLOP"
              : props.holiday.type === "sick"
              ? "CHOROBOWE"
              : props.holiday.type === "remote"
              ? "PRACĘ ZDALNĄ"
              : ""}
          </button>
          <button className="paymentMenuButton" onClick={deleteHoliday}>
            USUŃ{" "}
            {props.holiday.type === "holiday"
              ? "URLOP"
              : props.holiday.type === "sick"
              ? "CHOROBOWE"
              : props.holiday.type === "remote"
              ? "PRACĘ ZDALNĄ"
              : ""}
          </button>
        </div>
      </div>
    </>
  );
};

export default HolidayPopUp;
